import React from "react"
import PropTypes from "prop-types"
import EventNavbar from "components/CommonForBoth/EventNavbar"
import UpcomingEvents from "./Users/Events/UpcomingEvents"
import PastEventList from "./Users/Events/PastEventList"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import PageLoader from "components/Common/PageLoader"

const Frontend = props => {
  document.title = "Home | PULA Events"
  const navigate = useNavigate()
  const user = useSelector(state => state.auth.user)
  const token = useSelector(state => state.auth.token)
  useEffect(() => {
    if (user && token) {
      if (user.user_type === "admin" || user.user_type === "staff") {
        navigate("/dashboard")
      } else {
        navigate("/home")
      }
    } else {
      navigate("/login", { replace: true })
    }
  }, [])

  return (
    <>
      <div id="layout-wrapper">
        <PageLoader open={true} />
      </div>
    </>
  )
}

export default Frontend
